import {
  useActiveFeatureFlags as useActiveFeatureFlagPostHog,
  useFeatureFlagEnabled,
  useFeatureFlagPayload,
  useFeatureFlagVariantKey,
} from 'posthog-js/react';
import { getEnvironment } from '../../helpers';
import { FeatureFlag } from './types';

export function useFeatureFlag(flagKey: FeatureFlag) {
  const enabled = useFeatureFlagEnabled(flagKey);
  const variant = useFeatureFlagVariantKey(flagKey);
  const payload = useFeatureFlagPayload(flagKey);
  const activeFlags = useActiveFeatureFlagPostHog();

  return { enabled, variant, payload, activeFlags };
}

export const useActiveFeatureFlags = () => {
  const flags = useActiveFeatureFlagPostHog();
  return (getEnvironment(window.location.host) === 'dev' ? Object.values(FeatureFlag) : flags) as FeatureFlag[];
};
